import { render, staticRenderFns } from "./Personnel-selection.vue?vue&type=template&id=656f12d2&scoped=true"
import script from "./Personnel-selection.vue?vue&type=script&lang=js"
export * from "./Personnel-selection.vue?vue&type=script&lang=js"
import style0 from "./Personnel-selection.vue?vue&type=style&index=0&id=656f12d2&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "656f12d2",
  null
  
)

export default component.exports